import {ChatHistoryDTO} from "../../../../../../../api/generated";

export const getHierarchyContextKey = (chatHistory: ChatHistoryDTO): string => {
    return [
        chatHistory.activeFranchisePublicId || "",
        chatHistory.activeFranchiseContextSource || "",
        chatHistory.activeLocationPublicId || "",
        chatHistory.activeLocationContextSource || ""
    ].join("|");
}
